// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3mmz0","inputWrap":"Table_inputWrap__31NkD","col":"Table_col__2mdW4","bmiTooltip":"Table_bmiTooltip__11Rcz"};